import { isBlockedForProspecting } from "./crm-v2-policy.mjs";
import { reactivationSituation } from "./commercial.mjs";
export function sentenceCase(value) {
  const text=String(value || "").trim().toLocaleLowerCase("fr-FR");
  return text ? text[0].toLocaleUpperCase("fr-FR") + text.slice(1) : "";
}
const key=value=>String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g,"").trim().toLowerCase().replace(/\s+/g," ");
export function filterProspectingClients(clients,{filter="all",onlyMine=false,userId,today}={}) {
  filter = normalizeProspectingFilter(filter);
  return clients.filter(client=>{
    if(filter==="ambiguities")return false;
    if(isBlockedForProspecting(client))return false;
    if(onlyMine && (!userId || String(client.ownerId?._id || client.ownerId || "")!==String(userId || "")))return false;
    if(filter==="all" || filter==="uncontacted")return true;
    if(filter==="reactivation")return Boolean(reactivationSituation(client,today));
    if(filter==="prospects")return client.kind === "prospect" || key(client.status)==="prospect";
    if(filter==="active")return key(client.status)==="client actif";
    if(filter==="mine")return String(client.ownerId||"")===String(userId||"");
    return key(client.status)===key(filter);
  }).sort((a,b)=>(Number(b.score)||0)-(Number(a.score)||0) || String(a.name || "").localeCompare(String(b.name || ""),"fr"));
}

export { key as normalizeCommercialSearch };

export const prospectingFilters = [
  {value:"all",label:"Tous les établissements"},
  {value:"uncontacted",label:"Jamais contactés"},
  {value:"prospects",label:"Prospects"},
  {value:"active",label:"Clients actifs"},
  {value:"reactivation",label:"À réactiver"},
  {value:"favorites",label:"Mes favoris"},
  {value:"ambiguities",label:"Ambiguïtés"},
];
export function normalizeProspectingFilter(value) {
  const normalized = key(value);
  if (["a reactiver","client dormant","a reconquerir","client perdu","risk"].includes(normalized)) return "reactivation";
  if (normalized === "prospect") return "prospects";
  if (normalized === "client actif") return "active";
  return prospectingFilters.some(option=>option.value===value) || value === "mine" ? value : "all";
}
